<template>
<transition name="tranOpacity">
    <div
      v-if="isOpen"
      class="modal-overlay"
      @click="closeDialog($event)"
    >
      <transition name="slideAside">
        <div class="container shadow-md" @click.stop v-if="secondTransition"
          :ref="refNameContainer"
          role="dialog"
          aria-modal="true"
          :aria-label="ariaLabel"
          >
          <div class="overflow-y-auto flex flex-col h-full dark:bg-darkblue-900">
            <header class="sticky top-0 flex-none z-10">
              <slot name="header" />
            </header>
            <div class="h-full d-flex flex-row"
             :class="!isLower1024 ? 'h-full' : ''">
              <slot name="main" />
            </div>
          </div>
          <footer class="flex flex-col lg:flex-row items-center w-full lg:w-auto space-y-2 lg:space-y-0 lg:space-x-2 px-4 py-2 pb-4 bg-white dark:bg-darkblue-900">
            <slot name="footer" />
          </footer>
          <UtilKeys @keyup.esc="closeDialog" />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import UtilKeys from '@/components/utilities/UtilKeys'
import { dropdownState } from '@/state/dropdownState'
export default {
  name: 'base-dialog',
  components: {
    UtilKeys
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: 'Diálogo'
    },
    refNameContainer: {
      type: String,
      default: 'baseDialogContainer'
    }
  },
  data () {
    return {
      secondTransition: true
    }
  },
  watch: {
    isOpen: {
      deep: true,
      immediate: true,
      handler: 'watchisOpenHandler'
    },
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
  },
  methods: {
    closeDialog: function (event) {
      if (dropdownState.isAnyDropdownOpen) return
      if (this.isOpen) this.$emit('closeDialog')
    },
    watchisOpenHandler: async function () {
      const self = this
      if (self.secondTransition) self.secondTransition = !self.secondTransition
      else {
        // self.secondTransition = !self.secondTransition
        setTimeout(() => {
          self.secondTransition = !self.secondTransition
        }, 100)
      }
      setTimeout(() => {
        if (self.isOpen) {
          // console.log(self.$refs)
          self.$refs[this.refNameContainer].focus()
        }
      }, 500)

      // Focus trapping
      this.$nextTick(() => {
        if (this.isOpen) { 
          this.handleOpenModalDialogMixin(this.refNameContainer) 
        } else this.releaseFocusDialogMixin()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000088;
  z-index: 2020;
  overflow: auto;
}
.container {
  left:0;
  right:0;

  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
  margin-bottom: auto;
  position: relative;

  width: 40%;
  min-width: 320px;
  z-index: 101;

  background: white;
}
.slideAside-enter-active,
.slideAside-leave-active {
  transition: all 0.25s;
  transform: translateY(0%);
  opacity: 1;
}
.slideAside-enter,
.slideAside-leave-to {
  transition: all 0.25s;
  transform: translateY(-100%);
  opacity: 0;
}
.tranOpacity-enter-active,
.tranOpacity-leave-active {
  transition: all 0.25s;
  opacity: 1;
}
.tranOpacity-enter,
.tranOpacity-leave-to {
  transition: all 0.25s;
  opacity: 0;
}
.max-height-main{
  max-height: 400px;
}
</style>
